<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-toast styleClass='mt-5' key="auth-notification" [life]='5000'></p-toast>

<div class="d-flex flex-column justify-content-center gap-5">
  <div class="container">
    <div class="flex-container">
      <div class="card-style">
        <p-card>
          <form #form="ngForm" (ngSubmit)="save()" class="col-12 px-md">
            <div class="row">
              <div class="login-details-wrapper col-12">
                <div class="row pt-md pb-xl">
                  <h3 class="login-details-title">{{'auth.login-details' | translate}}: </h3>
                  <p-messages [(value)]="messages"></p-messages>
                </div>

                <auth-user-form [isNewUser]="isNewUser"
                                [isUserAccountValid]="userHasEmail"
                                [emailValue]="emailValue"
                                [userData]="userData"
                                [phoneNumberRequired]="userData?.companySuperAdmin ?? false"
                                [phoneNumberDisabled]='userData?.userPhoneDTO?.validated && !userData?.companySuperAdmin'
                ></auth-user-form>


                <div class="d-flex mt-4 col-12 pt-md pb-xl right gap-2">
                  <button (click)="back()" type="button" pButton [label]="'auth.cancel' | translate"
                          class="p-button-text" data-testid="cancel-btn"></button>
                  <button type="submit" pButton [label]="'auth.save' | translate" data-testid="save-btn"></button>
                </div>

              </div>
            </div>
          </form>
        </p-card>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="otp-card">
      <div class="card-style">
        <p-card>
          <auth-user-change-password
            [isNewUser]="isNewUser"
            [isUserAccountValid]="userHasEmail"
            [userUuid]="userData?.uuid"
            (submitChange)="changePassword($event)"
          >
          </auth-user-change-password>
        </p-card>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="!userData?.userPhoneDTO?.validated">
    <div class="otp-card">
      <div class="card-style">
        <p-card>
          <div class="col-12 px-3">
            <h3>{{'auth.validatePhoneNumber' | translate}}</h3>
            <div class="mt-3">
              <auth-user-otp-code-form [userUuid]="userData?.uuid"
                                       (phoneNumberValidated)='loadUserDetails(userData?.uuid)'>
              </auth-user-otp-code-form>
            </div>
          </div>
        </p-card>
      </div>
    </div>
  </div>
</div>
